import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getCategoryName, validLangs } from '@/mocks/languages';

export default function Guides() {
  const { t } = useTranslation();

  const guides = [
    { key: 'qc', id: 'qc', icon: 'ri-camera-lens-line', color: 'primary' },
    { key: 'shipping', id: 'shipping', icon: 'ri-truck-line', color: 'accent' },
    { key: 'review', id: 'review', icon: 'ri-star-line', color: 'secondary' },
    { key: 'safety', id: 'safety', icon: 'ri-shield-check-line', color: 'primary' },
  ];

  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700',
    accent: 'bg-accent-100 text-accent-800',
    secondary: 'bg-secondary-100 text-secondary-800',
  };

  return (
    <section id="guides" className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="text-center mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
          {t('home.guides.title')}
        </h2>
        <p className="mt-2 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
          {t('home.guides.subtitle')}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
        {guides.map((g) => (
          <div key={g.key} id={g.id} className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
            <span className={`inline-flex w-11 h-11 items-center justify-center rounded-lg ${colorMap[g.color]} mb-4`}>
              <i className={`${g.icon} text-xl`}></i>
            </span>
            <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg">
              {t(`home.${g.key}.title`)}
            </h3>
            <p className="mt-1 text-foreground-500 text-sm">{t(`home.${g.key}.subtitle`)}</p>
            <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
              {t(`home.${g.key}.body`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}